import Login from "Pages/Common/Login/Login";
import Clients from "Pages/Auth/Clients/Clients";
import AddClient from "Pages/Auth/Clients/AddClient";
import Banners from "Pages/Auth/Banners/Banners";
import AddBanners from "Pages/Auth/Banners/AddBanner";
import Exclusive from "Pages/Auth/Exclusive/exclusive";
import AddExclusive from "Pages/Auth/Exclusive/add";
import Category from "Pages/Auth/Category/Category";
import AddCategory from "Pages/Auth/Category/add";
import Campaigns from "Pages/Auth/campaigns/campaigns";
import AddCampaigns from "Pages/Auth/campaigns/add";
import GiveawayProducts from "Pages/Auth/Prizes/GiveawayProducts";
import AddGiveawayProducts from "Pages/Auth/Prizes/add";
import PromoCode from "Pages/Auth/Promocodes/prmocode";
import AddPromoCode from "Pages/Auth/Promocodes/add";
import Products from "Pages/Auth/Products/products";
import AddProducts from "Pages/Auth/Products/add";

import Users from "Pages/Auth/Users/Users";
import Explore from "Pages/Auth/Explore/explore";
import Orders from "Pages/Auth/Orders/Orders";
import OrderDetails from "Pages/Auth/Orders/Details";
import LuckyDraw from "Pages/Auth/LuckyDraw/draw";
import ExploreEdit from "Pages/Auth/Explore/updateexplore";
import DrawDetails from "Pages/Auth/LuckyDraw/details";
import ConfigData from "Pages/Auth/Config/config";
import UpdateConfigData from "Pages/Auth/Config/AddConfig";
import Notification from "Pages/Auth/Notifications/notifications";
import Dashboard from "Pages/Auth/dashboard/dashboard";
export const AuthConfig = [
    {
        path: "/clients",
        element: Clients,
    },
    {
        path: "/dashboard",
        element: Dashboard,
    },
    {
        path: "/clients/:type",
        element: AddClient,
    },
    {
        path: "/banners",
        element: Banners,
    },
    {
        path: "/banners/:type",
        element: AddBanners,
    },
    {
        path: "/exclusive",
        element: Exclusive,
    },
    {
        path: "/explore",
        element: Explore,
    },
    {
        path: "/explores/:type",
        element: ExploreEdit,
    },
    {
        path: "/exclusive/:type",
        element: AddExclusive,
    },
    {
        path: "/category",
        element: Category,
    },
    {
        path: "/category/:type",
        element: AddCategory,
    },
    {
        path: "/campaigns",
        element: Campaigns,
    },
    {
        path: "/campaigns/:type",
        element: AddCampaigns,
    },
    {
        path: "/give-away-products",
        element: GiveawayProducts,
    },
    {
        path: "/give-away-products/:type",
        element: AddGiveawayProducts,
    },
    {
        path: "/promocodes",
        element: PromoCode,
    },
    {
        path: "/promocodes/:type",
        element: AddPromoCode,
    },
    {
        path: "/Products",
        element: Products,
    },
    {
        path: "/Products/:type",
        element: AddProducts,
    },

    {
        path: "/users",
        element: Users,
    },
    {
        path: "/Orders",
        element: Orders,
    },
    {
        path: "/orders/:id",
        element: OrderDetails,
    },
    {
        path: "/draw",
        element: LuckyDraw,
    },
    {
        path: "/draw/:type",
        element: DrawDetails,
    },
    {
        path: "/config",
        element: ConfigData,
    },
    {
        path: "/config/:type",
        element: UpdateConfigData,
    },
    {
        path: "/notifications",
        element: Notification,
    },
];

export const Config = [
    {
        path: "/",
        element: Login,
    },
];
